export default __webpack_public_path__ + "f1cd2c61e426c5fccd92be14679e6cb8.svg";